import { ChangeDetectorRef, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule, DatePipe, Location } from '@angular/common';
import {
  ApiService,
  AuthService,
  CampaignService,
  EventsService,
  HomepageService,
  UtilService,
  VariablesService,
} from 'src/app/shared/services';
import {
  ICampaignPayload,
  IFormInfo,
  ILeadPayload,
  TLang,
} from './form-fileds.model';
import { EN_OTHER_INFO, EN_SAF_FORM_INFO } from './translations/en';
import { HI_OTHER_INFO, HI_SAF_FORM_INFO } from './translations/hi';
import { TA_OTHER_INFO, TA_SAF_FORM_INFO } from './translations/ta';
import { TE_OTHER_INFO, TE_SAF_FORM_INFO } from './translations/te';
import { FormComponent } from './form/form.component';
import { StepperComponent } from './stepper/stepper.component';
import { environment } from 'src/environments/environment';
import { IUser } from 'src/app/shared/models';
import { SigninSignupComponent } from '../signin-signup/signin-signup.component';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FormGroup } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BOTTOM_BUTTON_LABELS } from './translations/btnLabel';
import { STEP_BUTTON_LABELS } from './translations/STEP_BUTTON_LABELS';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonDraftFundraiserComponent } from 'src/app/shared/components/common-draft-fundraiser/common-draft-fundraiser.component';


@Component({
  selector: 'app-saf',
  standalone: true,
  imports: [
    CommonModule,
    FormComponent,
    StepperComponent,
    SigninSignupComponent,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule
  ],
  providers: [DatePipe],
  templateUrl: './saf.component.html',
  styleUrls: ['./saf.component.scss'],
})
export class SafComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly auth = inject(AuthService);
  private readonly homeService = inject(HomepageService);
  private readonly api = inject(ApiService);
  private readonly campaignService = inject(CampaignService);
  private readonly dialog = inject(MatDialog);
  private readonly events = inject(EventsService);
  private readonly router = inject(Router);
  private readonly datePipe = inject(DatePipe);
  public location = inject(Location);
  public readonly util = inject(UtilService);
  public readonly vars = inject(VariablesService);
  public environment = environment;
  public logoUrlLight: any;

  dialogRefUnderReview: MatDialogRef<any>;

  isLoading: boolean = true;
  draftID: any;
  draftData: any;
  causeName: string = '';

  formInfo!: IFormInfo;
  otherInfo: any;
  selectedLang: TLang = 'en';
  userData: IUser;
  phoneData;
  buttonLabels = BOTTOM_BUTTON_LABELS[this.selectedLang];

  formGroup: FormGroup = new FormGroup({});;
  formData: any = {};

  supportedLang: { key: TLang; label: string }[] = [
    { key: 'en', label: 'English' },
    { key: 'hi', label: 'Hindi' },
    { key: 'ta', label: 'Tamil' },
    { key: 'te', label: 'Telugu' },
  ];

  @ViewChild('formInstance') formInstance: FormComponent;
  @ViewChild('langSelect') langNavSelectRef: ElementRef<HTMLSelectElement>;

  termsUrl = '/terms-of-use.php';
  privacyUrl = '/privacy-policy.php';
  plansUrl = '/support/plans-and-pricing.php';


  isSelectOpen = false;
  showFullLoader = false;

  ngOnInit() {
    this.isLoading = true;
    this.util.loadIcons();
    const lang = this.util.storage.get('safLanguage');
    this.selectedLang = lang || 'en';
    this.logoUrlLight = this.util.logoUrlLight;

    this.util.doc?.body?.classList?.add('dmsans');
    this.userData = this.vars.userData.getValue();
    this.phoneData = this.util.storage.getFromSession('firebasePhoneData') || undefined;
    if (this.phoneData) {
      this.onFirebaseRes(this.phoneData);
    }
    this.setLang(this.selectedLang);

    this.setAgreeUrl()

    this.vars.userData.subscribe(u => {
      if (u) {
        this.userData = u;
      }
    });
  }

  onSelectOpened() {
    this.isSelectOpen = true;
  }

  onSelectClosed() {
    this.isSelectOpen = false;
  }

  async ngAfterViewInit() {
    this.vars.pageName = 'new_saf';
    this.sendEvent({
      eventName: "pageView",
      page_name: "new_saf",
    });
    await this.getDraftID();
    this.isLoading = false;
  }

  setLang(val: TLang) {
    this.selectedLang = val;
    switch (true) {
      case val === 'hi':
        this.formInfo = HI_SAF_FORM_INFO;
        this.otherInfo = HI_OTHER_INFO;
        this.setAgreeUrl()
        break;

      case val === 'ta':
        this.formInfo = TA_SAF_FORM_INFO;
        this.otherInfo = TA_OTHER_INFO;
        this.setAgreeUrl()
        break;

      case val === 'te':
        this.formInfo = TE_SAF_FORM_INFO;
        this.otherInfo = TE_OTHER_INFO;
        this.setAgreeUrl()
        break;

      default:
        this.formInfo = EN_SAF_FORM_INFO;
        this.otherInfo = EN_OTHER_INFO;
        this.setAgreeUrl()
        break;
    }
    this.buttonLabels = BOTTOM_BUTTON_LABELS[this.selectedLang];
    this.util.storage.check('safLanguage', this.selectedLang);
  }

  onFirebaseRes(e) {
    this.phoneData = e;
    this.util.storage.checkFromSession('firebasePhoneData', this.phoneData);
    this.sendLead({
      about: 'Start a fundraiser',
      name: 'user',
      email: `${this.phoneData?.phone}.dummy@ketto.org`,
      extension: this.phoneData?.extension,
      phone: this.phoneData?.phone,
      query_type: 'want_to_raise_funds',
      subject: 'SAC signup-You received a new lead',
      type: 'P - SAF Step 0',
    });
  }

  setAgreeUrl() {
    this.formInfo.agree.label = this.formInfo.agree.label
      .replace('{{terms}}', this.termsUrl)
      .replace('{{privacy}}', this.privacyUrl)
      .replace('{{plans}}', this.plansUrl);
  }

  onFormChange(e) {
    this.formGroup = e?.formGroup;
    this.formData = e?.formData;
    this.causeName = e?.causeName;
  }

  // Helper Methods
  sendEvent(data: {
    eventName: string;
    page_name?: string;
    info_1?: string;
    info_2?: string;
    info_3?: string;
    event_type?: string;
    event_type_id?: number,
  }) {
    this.events.sendSystemEvent(data).subscribe((_) => _);
  }

  sendLead(data: ILeadPayload, multiLead = false) {
    if (data.alloMultiLead) {
      multiLead = true;
      delete data.alloMultiLead;
    }
    const payload: ILeadPayload = {
      page: this.vars.pageName,
      type: 'campaign',
      email: this.userData?.email,
      name: this.userData?.full_name || '',
      extension: this.phoneData?.extension || this.userData?.extension,
      phone: this.phoneData?.phone || this.userData?.phone_1,
      user_id: this.userData?.id,
      mail_to: this.vars.leadMailTo,
      ...data,
    };
    this.homeService.postLeadData(payload, true, multiLead).subscribe({
      next: (res: any) => {
        if (payload.type === 'P - SAF Step 0') {
          this.sendEvent({
            eventName: 'campaign_lead_created',
            event_type: 'campaign',
            info_2: res?.data?.id,
          });
        }
      },
      error: (err: any) => {
        // console.log(err);
      },
    });
  }

  private async handleDraft(data: any) {
    this.vars.draftData.next(data);
    if (data?.parent_cause_id === 48) {
      this.vars.campaignPurpose = 'ngo';
    } else if (
      data?.parent_cause_id === 20 &&
      this.vars.validCausePM.includes(data?.cause_id)
    ) {
      this.vars.campaignPurpose = 'medical';
    } else if (
      data?.parent_cause_id === 20 &&
      !this.vars.validCausePM.includes(data?.cause_id)
    ) {
      this.vars.campaignPurpose = 'other';
    }

    if (this.draftID) {
      await this.getDraftDetails();
    }
  }

  onLogoClick(event) {
    event.preventDefault();
    this.util.router.navigate(['/']);
  }

  getBackOrStartLabel(): string {
    const labels = STEP_BUTTON_LABELS[this.selectedLang] || STEP_BUTTON_LABELS['en'];
    return this.formInstance?.isFinalStep ? labels.back : labels.start;
  }

  //For payload creations of create and updateCampaign
  private createCampaignPayload(keys: string[]): ICampaignPayload {
    const formData = this.formData;
    const payload: ICampaignPayload = {};

    if (formData?.sameCityAsHospital) {
      formData.city = formData?.hospital?.city;
    }

    for (const key of keys) {
      switch (key) {
        case 'beneficiaryage':
          payload[key] = {
            entity_type: 'campaign',
            info_1: formData?.age ?? '',
            info_type: 'beneficiary_age',
          };
          break;

        case 'disease':
          const disease = formData?.ailment || {};
          payload[key] = {
            entity_type: 'campaign',
            info_1: disease.name || disease.full_name || disease.info_1 || '',
            info_2: disease.info_2 ?? '',
            info_type: 'disease',
          };
          break;

        case 'hospital':
          const requiresHospital =
            formData?.hospitalisation !== 'Does not require hospitalisation';
          payload[key] = {
            entity_type: 'campaign',
            info_1: requiresHospital ? formData?.hospital?.name || formData?.hospital?.full_name || '' : '',
            info_2: formData?.hospital?.info_2 ?? '',
            info_3: formData?.hospitalisation ?? '',
            info_type: 'hospital',
          };
          break;

        case 'address':
          const parts = (formData?.city || '').split(',').map((p) => p.trim());
          payload['address_1'] = parts[0] || '';
          payload['address_2'] = parts[1] || '';
          payload['address_3'] = parts[2] || '';
          break;

        case 'beneficiaryrelation':
          if (formData.raisingFor !== 'self') {
            payload[key] = {
              entity_type: 'campaign',
              info_1: formData?.relation ?? '',
              info_type: 'beneficiary_relation',
            };
          }
          break;

        case 'beneficiaryname':
          payload[key] = {
            entity_type: 'campaign',
            info_1:
              formData.raisingFor === 'self'
                ? formData?.name ?? ''
                : formData?.beneficiaryName ?? '',
            info_type: 'beneficiary_name',
          };
          break;

        case 'amount_requested':
          payload[key] = formData?.fundRequired ?? '';
          break;

        case 'cause_id':
          let cause = formData?.cause ?? "";
          if (formData.relation === 'Pet') {
            cause = 61;
            this.util.storage.checkFromSession('safForm', { ...formData, cause: 61 })
          }
          payload[key] = cause ?? "";
          break;

        case 'parent_cause_id':
          const parent_cause_id = formData?.raisingFor === "ngo" ? "48" : "20";
          payload[key] = parent_cause_id ?? "";
          break;

        case 'entity_details_id':
          const entity_details_id = formData?.ngo?.id ?? "";
          payload[key] = entity_details_id ?? '';
          break;

        case 'title':
          payload[key] = formData?.title ?? '';
          break;

        case 'about':
          let about = formData?.about;
          if (formData?.cause !== 59 && about && formData?.aboutMerge) {
            about += `<br/><p>${formData?.aboutMerge}</p>`;
          }
          payload[key] = {
            entity_type: 'campaign',
            info_1: about ?? '',
            info_type: 'social',
          };
          break;

        case 'agree':
          payload[key] = formData?.agree;
          break;

        default:
          console.warn(`Unknown key in payload creation: ${key}`);
          break;
      }
    }

    // Remove fields if cause is not 59
    if (formData?.raisingFor !== 'ngo' && formData?.cause !== 59) {
      delete payload.hospital;
      delete payload.disease;
      delete payload.entity_details_id;
    }

    if (formData?.raisingFor === 'self') {
      delete payload.beneficiaryrelation;
      delete payload.entity_details_id;
    }

    if (formData?.raisingFor === 'someoneElse') {
      delete payload.entity_details_id;
    }

    if (formData?.raisingFor === 'ngo') {
      delete payload.hospital;
      delete payload.disease;
      delete payload.beneficiaryrelation;
      delete payload.beneficiaryage;
      delete payload.beneficiaryname;
      delete payload.address_1
      delete payload.address_2
      delete payload.address_3
    }

    return payload;
  }

  //API Calls
  private async getDraftID(): Promise<any> {
    if (!this.userData) return null;
    this.isLoading = true;
    const url = environment.APP.API_URLS.GET_DRAFT_FR();
    try {
      const res = await firstValueFrom(this.api.get(url, 'false'));
      const data = res.data;
      if ([8].includes(data?.status_flag)) {
        this.dialogRefUnderReview = this.dialog.open(CommonDraftFundraiserComponent, {
          maxWidth: '100vw',
          width: '500px',
          panelClass: 'underReviewModal',
          disableClose: true,
          data,
          closeOnNavigation: true,
        });
        return data;
      }
      this.draftID = data?.id;
      this.handleDraft(data);
      return data;
    } catch (err: any) {
      console.error('Error fetching draft ID:', err);
    } finally {
      this.isLoading = false;
    }
  }

  private async getDraftDetails(): Promise<void> {
    try {
      this.isLoading = true;
      const res: any = await firstValueFrom(
        this.campaignService.getCampaignDraft(this.draftID, false)
      );

      const data = (this.draftData = res.data);
      this.draftID = this.draftData.id;
      this.vars.draftObs.next(res.data);

      if (res.data.event_entity_details_id) {
        this.campaignService.micrositeCampaigns.entity_type = 'events';
        this.campaignService.micrositeCampaigns.entity_id =
          res.data.event_entity_details_id;
      }

      let raisingFor = 'self';
      let relation = '';
      if (data.parent_cause_id === 20) {
        const info_1 = data?.beneficiaryrelation?.info_1;
        if (info_1) {
          relation = info_1;
          raisingFor = 'someoneElse';
        }
      }

      let ailment = null;
      if (data.disease) {
        ailment = {
          id: data.disease?.id,
          name: data.disease?.info_1 ?? '',
          info_2: data.disease?.info_2 ?? '',
        }
      }

      let hospital = null;
      if (data.hospital) {
        hospital = {
          id: data.hospital?.id,
          name: data.hospital?.info_1 ?? '',
          info_2: data.hospital?.info_2 ?? '',
        }
      }

      if (data.parent_cause_id === 48) {
        raisingFor = 'ngo';
        let ngo = {}

        if (data.beneficiary) {
          ngo = {
            fname: data.beneficiary.fname,
            full_name: data.beneficiary.full_name,
            id: data.beneficiary.id,
            profileIncomplete: data.beneficiary.profileIncomplete,
            tax_benefit: data.beneficiary.tax_benefit
          }
        }

        const draftData = {
          name: data?.beneficiaryname?.info_1 || this.userData?.full_name,
          email: this.userData?.email,
          raisingFor,
          fundRequired: data.amount_requested,
          cause: data.cause.id,
          ngo
        };
        this.formInstance.prefill(draftData)
        return;
      }

      if (![59, 57, 71].includes(data?.cause?.id)) {
        this.formInstance.showList = true;
      }

      const draftData = {
        name: this.userData?.full_name,
        email: this.userData?.email,
        raisingFor,
        relation,
        fundRequired: data?.amount_requested,
        age: data?.beneficiaryage?.info_1,
        cause: data?.cause?.id,
        causeName: data?.cause?.info_1,
        ailment: ailment ?? '',
        hospitalisation: data?.hospital?.info_3 || 'Does not require hospitalisation',
        hospital: hospital ?? '',
        city: [data?.address_1, data?.address_2, data?.address_3].filter((p) => p).join(', '),
        beneficiaryName: data?.beneficiaryname?.info_1,
        title: data?.cause?.id === 59 ? data?.title ?? "" : "",
        about: data?.cause?.id === 59 ? data?.about?.info_1 ?? "" : ""
      };

      setTimeout(() => {
        // this.formInstance.setFinalStep();
        this.formInstance.prefill(draftData)
      }, 10);


      this.util.storage.checkFromSession('safForm', draftData);
    } catch (err) {
      // console.log(err)
    }
    finally {
      this.isLoading = false;
    }
  }

  private async createCampaign(payload: ICampaignPayload): Promise<void> {
    try {
      this.isLoading = true;
      const res: any = await firstValueFrom(
        this.campaignService.createCampaign(payload)
      );
      this.draftID = res?.data?.id;
      this.sendEvent({
        eventName: "start_a_campaign_step1_completed",
        event_type: "campaign",
        event_type_id: this.draftID,
        info_1: 'Step 1 Completed',
        info_3: this.util.storage.get('safLanguage') || 'English',
      });
      this.gtmPush(res?.data);
      return res;
    } catch (err) {
      console.error('Error creating campaign:', err);
      throw err;
    } finally {
      this.isLoading = false;
    }
  }

  gtmPush(data) {
    const dataPush = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: data?.parent_cause_name,
      eventLabel: 'step1_completed',
      Campaign_cause_id: data?.cause_id,
      Campaign_id: Number(data?.draftid),
      Campaign_Type: data?.parent_cause_name
    };
    this.events.gtmPush(dataPush);
  }

  async updateCampaignDraft(payload: ICampaignPayload): Promise<void> {
    try {
      this.isLoading = true;
      const url = environment.APP.API_URLS.UPDATE_CAMPAIGN(this.draftID);
      const res: any = await firstValueFrom(this.api.put(url, payload));
      return res;
    } catch (err) {
      console.error('Error updating campaign draft:', err);
      throw err;
    } finally {
      this.isLoading = false;
    }
  }

  gtmPushOnUpdate() {
    const dataPush = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draftData?.parent_cause_id),
      eventLabel: 'step3_completed',
      Campaign_cause_id: this.draftData?.cause_id,
      Campaign_id: this.draftData?.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draftData?.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }

  sendDraftLead() {
    const payload: any = {
      type: 'Preapproved campaign',
      subject: 'Draft campaign',
      parent_cause_id: this.draftData?.parent_cause_id,
      cause_id: this.draftData?.cause_id,
      cause_name: this.draftData?.cause?.info_1,
      description: this.formData?.about,
      CID: this.draftData?.id
    };
    this.events.sendLead(payload);
  }

  async publishCampaign(): Promise<any> {
    try {
      this.isLoading = true;

      //for medical
      const payload: any = {
        status_flag: 8,
      };

      //for non medical
      if (this.formData.cause !== 59) {
        payload.status_flag = 3;
      }

      if (typeof this.formData?.insuranceOptIn !== 'undefined') {
        payload.insurance_opt_in = this.formData?.insuranceOptIn;
        this.events.sendSystemEvent({eventName: 'insurance_optin', info_1: this.formData.insuranceOptIn}).subscribe(_ => _);
      }

      const url = environment.APP.API_URLS.PUBLISH_CAMPAIGN(this.draftID);
      const res = await lastValueFrom(this.api.put(url, payload));
      this.sendLead(this.util.removeEmptyFromObject({
        description: this.formData?.about,
        age: this.formData?.age,
        CID: this.draftID,
        cause_id: this.formData?.cause,
        cause_name: this.formInstance?.causeName,
        city: this.formData?.city,
        email: this.userData?.email,
        extension: this.phoneData?.extension || this.userData?.extension,
        goal_amount: this.formData?.fundRequired,
        hospital_name: this.formData?.hospital?.full_name,
        hospitalization_status: this.formData?.hospitalisation,
        medical_condition: this.formData?.ailment?.name,
        parent_cause_id: this.formData?.raisingFor === 'ngo' ? 48 : 20,
        patient_name: this.formData?.beneficiaryName || this.formData?.name,
        relation: this.formData?.raisingFor === 'someoneElse' ? this.formData?.relation : this.formData?.raisingFor,
        subject: 'Draft campaign',
        type: 'P - Draft campaign (Step 2)'
      }));
      this.sendEvent({
        eventName: "start_a_campaign_step2_completed",
        event_type: "campaign",
        event_type_id: this.draftID,
        info_1: 'Step 2 Completed',
        info_3: this.util.storage.get('safLanguage') || 'English',
      });
      this.cleverTapPublishPush(res);
      return res;
    } catch (err) {
      console.error('Error publishing campaign:', err);
      throw err;
    } finally {
      this.isLoading = false;
    }
  }

  cleverTapPublishPush(publishData) {
    const campaign_start_date = publishData?.data?.start_date ? new Date(publishData?.data?.start_date) : new Date();
    campaign_start_date.setDate(campaign_start_date.getDate() + 15);
    const campaign_expiry_date = this.datePipe.transform(campaign_start_date, 'yyyy-MM-dd');
    const cleverTap = {
      'CampaignerName': this.draftData?.owner?.full_name,
      'CampaignID': this.draftData?.id,
      'CampaignerMobile': this.draftData?.owner?.phone_1 || this.userData?.phone_1,
      // 'Guardian': guardian,
      // 'PatientMobile': patientMobile,
      'PatientName': this.draftData?.beneficiaryname?.info_1,
      'PatientAge': this.draftData?.beneficiaryage?.info_1,
      'AmountTBRaised': this.draftData?.amount_requested,
      'PatientRelationWithCampaigner': this.draftData?.beneficiaryrelation?.info_1 || '',
      'PatientDisease': this.draftData?.disease?.info_1 || '',
      'PatientHospital': this.draftData?.hospital?.info_1 || 'Not Admitted',
      'CampaignURL': `${this.util.domain_details.domain_url}/fundraiser/${publishData?.data?.custom_tag}`,
      'ParentCauseID': this.draftData?.parent_cause_id,
      'CauseID': this.draftData?.cause_id,
      'FundraiserExpiryDate': campaign_expiry_date,
      'UrlencodeCampaignName': encodeURI(publishData?.data?.title),
      'CustomTag': `${publishData?.data?.custom_tag}`
    };
    if (this.draftData?.parent_cause_id === 20 && this.draftData?.cause_id === 59 && this.draftData?.disease?.info_2) {
      cleverTap['ParentDiseaseId'] = this.draftData.disease.info_2;
      cleverTap['City'] = this.draftData?.address_1;
    }
    this.events.claverTapPush('Fundraiser Started', cleverTap);
    console.log('ct data: Fundraiser Started: ', cleverTap);
    const data = {
      Site: {
        'CampaignID': this.draftData.id,
        'SAF_Language': this.util.storage.get('safLanguage') || 'English',
        'Identity': this.userData?.id,
        'Email': this.userData?.email,
      }
    };
    this.events.claverProfilePush(data)
  }

  //CTA Methods
  //On Review CTA
  async reviewFundraiser() {
    this.isLoading = true;
    this.cdr.detectChanges();
    const keys = [
      'amount_requested',
      'beneficiaryrelation',
      'beneficiaryname',
      'beneficiaryage',
      'disease',
      'hospital',
      'address',
      'cause_id',
      'parent_cause_id',
      'entity_details_id'
    ];
    if (this.draftData) {
      const update_payload = this.createCampaignPayload(keys);
      await this.updateCampaignDraft(update_payload);
      await this.getDraftDetails();
      await this.updateMeData();
      setTimeout(() => {
        this.formInstance.setFinalStep();
        this.cdr.detectChanges();
      }, 100);
      this.isLoading = false;
      return;
    }

    const date = new Date();
    let create_payload = this.createCampaignPayload(keys);
    create_payload.title = `Draft fundraiser created on ${date.getDate()}/${date.getMonth() + 1
      }/${date.getFullYear()}`;
    try {
      await this.createCampaign(create_payload);
      await this.updateCampaignDraft(create_payload);
      // console.log(this.formData);
      this.sendLead(this.util.removeEmptyFromObject({
        age: this.formData?.age,
        CID: this.draftID,
        cause_id: this.formData?.cause,
        cause_name: this.formInstance?.causeName,
        city: this.formData?.city,
        email: this.userData?.email,
        extension: this.phoneData?.extension || this.userData?.extension,
        goal_amount: this.formData?.fundRequired,
        hospital_name: this.formData?.hospital?.full_name,
        hospitalization_status: this.formData?.hospitalisation,
        medical_condition: this.formData?.ailment?.name,
        parent_cause_id: this.formData?.raisingFor === 'ngo' ? 48 : 20,
        patient_name: this.formData?.beneficiaryName || this.formData?.name,
        relation: this.formData?.raisingFor === 'someoneElse' ? this.formData?.relation : this.formData?.raisingFor,
        subject: 'Draft campaign',
        type: 'P - Draft campaign (Step 1)'
      }));
      await this.getDraftDetails();
      setTimeout(() => {
        this.formInstance.setFinalStep();
        this.cdr.detectChanges();
      }, 100);
      this.isLoading = false;
      // this.util.openSnackBar('Campaign updated successfully', 'success');
    } catch (err) {
      console.error('Error creating or fetching draft campaign:', err);
      this.util.openSnackBar(
        'Something went wrong. Please try again.',
        'error'
      );
    }
  }

  //On Start Fundraiser CTA
  async startFundraiser() {
    const keys = ['title', 'about', 'agree'];
    const publish_payload = this.createCampaignPayload(keys);
    await this.updateCampaignDraft(publish_payload);
    this.gtmPushOnUpdate();
    this.sendDraftLead();
    const publishResponse = await this.publishCampaign();
    // this.util.openSnackBar('Fundraiser Successfully created', 'success');

    //For medical
    if (this.formData.cause === 59) {
      this.router.navigate(['new/campaign-thank-you'], {
        queryParams: {
          type: 'medical',
          custom_tag: publishResponse.data.custom_tag,
        },
        queryParamsHandling: '',
      });
    }

    //For non medical
    if (this.formData.cause !== 59) {
      this.router.navigate([`/new/campaign-review-page`], {
        queryParams: {
          type: 'non-medical',
          parent_cause_id: publishResponse?.data?.parent_cause_id,
          cause_id: publishResponse?.data?.cause_id,
          campaign_id: publishResponse?.data?.id
        },
      });
    }

    this.util.storage.deleteFromSession('safForm');
  }

  updateMeData() {
    return new Promise(resolve => {
      this.auth.getUserProfile().subscribe({
        next: (res: any) => {
          this.util.setUserData(res.data);
          resolve(res.data);
        },
        error: (error) => {
          resolve(null);
        }
      });
    });
  }


  //On Back CTA
  goBack() {
    if (this.formInstance.isFinalStep) {
      this.formInstance.isFinalStep = false;
      this.formInstance.addRemoveControl(['title', 'about', 'aboutMerge', 'media', 'agree', 'insuranceOptIn'], 'remove');
      return;
    }
    this.router.navigate(['/']);
  }

  triggerSelect(): void {
    const select = this.langNavSelectRef?.nativeElement;
    if (select) {
      select.focus();
      const event = new KeyboardEvent('keydown', { key: 'ArrowDown' });
      select.dispatchEvent(event);
    }
  }

  ngOnDestroy() {
    this.util.doc ? this.util.doc?.body?.classList?.remove('dmsans') : null;
  }
}
